// // import axios from "axios";

// // const api = axios.create({
// //   baseURL: "http://localhost:4000",
// // });

// // api.interceptors.request.use((config) => {
// //   const token = localStorage.getItem("token");
// //   if (token) {
// //     config.headers.Authorization = `Bearer ${token}`;
// //   }
// //   return config;
// // });

// // export default api;
// import axios from "axios";

// const api = axios.create({
//   baseURL: import.meta.env.VITE_API_URL,
//   withCredentials: true, // 🔑 IMPORTANT for refresh cookie
// });

// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//   failedQueue.forEach((p) => {
//     if (error) {
//       p.reject(error);
//     } else {
//       p.resolve(token);
//     }
//   });
//   failedQueue = [];
// };

// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // 🚫 Not auth error
//     if (error.response?.status !== 401 || originalRequest._retry) {
//       return Promise.reject(error);
//     }

//     // 🔁 Already refreshing → queue request
//     if (isRefreshing) {
//       return new Promise((resolve, reject) => {
//         failedQueue.push({ resolve, reject });
//       }).then((token) => {
//         originalRequest.headers.Authorization = `Bearer ${token}`;
//         return api(originalRequest);
//       });
//     }

//     originalRequest._retry = true;
//     isRefreshing = true;

//     try {
//       // 🔄 CALL REFRESH API
//       const res = await axios.post(
//         `${import.meta.env.VITE_API_URL}/auth/refresh`,
//         {},
//         { withCredentials: true }
//       );

//       const newAccessToken = res.data.accessToken;

//       localStorage.setItem("token", newAccessToken);
//       api.defaults.headers.Authorization = `Bearer ${newAccessToken}`;

//       processQueue(null, newAccessToken);

//       return api(originalRequest);
//     } catch (refreshError) {
//       processQueue(refreshError, null);

//       // ❌ Refresh failed → logout
//       localStorage.removeItem("token");
//       window.location.href = "/";

//       return Promise.reject(refreshError);
//     } finally {
//       isRefreshing = false;
//     }
//   }
// );

// export default api;
import axios from "axios";

const BASE_URL =
  import.meta.env.VITE_API_URL || "https://crm.backend.thefither.com";

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // 🔑 needed for refresh cookie
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((p) => {
    error ? p.reject(error) : p.resolve(token);
  });
  failedQueue = [];
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config || {};

    if (
      error.response?.status !== 401 ||
      originalRequest._retry ||
      originalRequest.url?.includes("/auth/refresh")
    ) {
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then((token) => {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return api(originalRequest);
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      const res = await axios.post(
        `${BASE_URL}/auth/refresh`,
        {},
        { withCredentials: true }
      );

      const newAccessToken = res.data.accessToken;
      if (!newAccessToken) throw new Error("No access token");

      localStorage.setItem("token", newAccessToken);
      api.defaults.headers.Authorization = `Bearer ${newAccessToken}`;

      processQueue(null, newAccessToken);
      return api(originalRequest);
    } catch (err) {
      processQueue(err, null);
      localStorage.removeItem("token");
      window.location.href = "/";
      return Promise.reject(err);
    } finally {
      isRefreshing = false;
    }
  }
);

export default api;
